export const LINKS = {
  twitter: "https://twitter.com/aevoxyz",
  discord: "https://discord.com/invite/aevo",
  github: "https://github.com/aevoxyz",
  blog: "https://mirror.xyz/aevo.eth",
  termsOfService: "https://discord.com/invite/aevo",
  exchange: "https://app.aevo.xyz/",
  admin: "admin-aevo-otc.vercel.app"
} as const;
